import instance from './instance';

export const getWorkspacePrivateNote = ({ workspaceId, userId }) =>
  instance.get('/api/v0/workspace_private_notes', { params: { workspaceId, userId } });

export const createOrUpdateWorkspacePrivateNote = ({ text, workspaceId }) =>
  instance.put(`/api/v0/workspace_private_notes/create_or_update`, { text, workspace_id: workspaceId });
